import React from "react";
import { Link, useLocation } from "react-router-dom";
import CreateCampaign from "./CreateCampaign";

const Sidebar = ({ resetSearchAndGenre, accessToken, pointsRef, points, campaignsRef }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <ul className="sidebar-menu">
      <li className={isActive("/") ? "active" : ""}>
        <Link to="/" onClick={resetSearchAndGenre}>
          Home
        </Link>
      </li>
      <li className={isActive("/my-campaigns") ? "active" : ""}>
        <Link to="/my-campaigns" onClick={resetSearchAndGenre}>
          My Campaigns
        </Link>
      </li>
      <CreateCampaign
        accessToken={accessToken}
        points={points}
        pointsRef={pointsRef}
        campaignsRef={campaignsRef}
      />
      <li className={isActive("/listen-and-earn") ? "active" : ""}>
        <Link to="/listen-and-earn" onClick={resetSearchAndGenre}>
          Listen And Earn Credits
        </Link>
      </li>
      <li className={isActive("/shop") ? "active" : ""}>
        <Link to="/shop" onClick={resetSearchAndGenre}>
          Shop
        </Link>
      </li>
      <li className={isActive("/buy-beatcoins") ? "active" : ""}>
        <Link to="/buy-beatcoins" onClick={resetSearchAndGenre}>
          Buy BeatCoins
        </Link>
      </li>
      <li className="logout-link">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.5 24L31.5 18M31.5 18L25.5 12M31.5 18H10.5M19.5 24V25.5C19.5 27.9854 17.4854 30 15 30H9C6.51473 30 4.5 27.9854 4.5 25.5V10.5C4.5 8.01473 6.51473 6 9 6H15C17.4854 6 19.5 8.01473 19.5 10.5V12" stroke="#9FFF9A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <a href="https://accounts.spotify.com">
          Log out
        </a>
      </li>
    </ul>
  );
};

export default Sidebar;